<div id="wrap" class="practiceList-bgblue">
  <div id="closeBtn" class="common-back-btn-sight" (click)="close();" *ngIf="type!== 'huatek'" >
    <span >×</span>
  </div>

  <div id="head_wrap" class="fontSize18">
    情景模拟
  </div>

  <!-- 提醒 -->
  <app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

<!--  <div *ngIf="practiceList">-->
<!--    <div class="practiceList-listeImgItem" [ngStyle]="{'background-image': practiceList[0].extends ? practiceList[0].extends.bg : '' }" (click)="goToNextStep(0)">-->
<!--      <div class="practiceList-listeImgItemHead-Img">-->
<!--        <img *ngIf="practiceList[0].extends && practiceList[0].extends.userPhoto != ''" src="{{practiceList[0].extends.userPhoto}}" class="practiceList-icon"  />-->
<!--      </div>-->
<!--      <div class="practiceList-listeImgItemHead fontSize16">-->
<!--        {{practiceList[0].title}}-->
<!--      </div>-->
<!--      <div class="practiceList-listeImgItemContent fontSize14 lineHeight21">-->
<!--        {{practiceList[0].description}}-->
<!--        <div class="entryBtn">进入</div>-->
<!--      </div>-->

<!--    </div>-->

<!--  </div>-->

  <div *ngIf="practiceList">
    <div class="practiceList-listeImgItem" [ngStyle]="{'background-image': practice.extends ? practice.extends.bg : '' }" *ngFor="let practice of practiceList;let i = index" (click)="goToNextStep(i)">
      <div class="practiceList-listeImgItemHead-Img">

        <img *ngIf="practice.extends && practice.extends.userPhoto != ''" src="{{practice.extends.userPhoto}}" class="practiceList-icon"  />
        <div *ngIf="practice.status == 2" class="practice-status">
          已完成
        </div>
        <div *ngIf="practice.momentsList.length > 0" class="momentImg" (click)="momentView(practice.momentsList,$event)">
          <img [src]="'assets/picture/casemission/moment/' + practice.momentsList[0] + '.png'"  />
          <div class="viewtip" *ngIf="showToast && toastIndex == i">点击图标查看“难忘瞬间”</div>
        </div>
      </div>
      <div class="practiceList-listeImgItemHead fontSize16">
        {{practice.title}}
      </div>
      <div class="practiceList-listeImgItemContent fontSize14 lineHeight21">
        {{practice.description}}
        <div class="entryBtn">进入</div>
      </div>
    </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&isShowQuestionnaire">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&!isShowQuestionnaire">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>

  </div>
  <!--<div  *ngIf="!learningTour && finished"  id="surveyWrap">
    <p [innerHtml]="chuanjie" class="fontSize16 lineHeight21"></p>
  </div>
  -->
</div>
<!--<div id="nextWrap" [ngClass]="{'nextWrapAfter': finishStatus == true,-->
<!--                             'nextWrapBefore': finishStatus == false}" (click)="finish()">-->
<!--  <div id="nextStudy" *ngIf="finishStatus" class="nextStudy fontSize16">-->
<!--    已完成本能力的学习-->
<!--  </div>-->
<!--  <div id="nextStudy" *ngIf="!finishStatus" class="nextStudy fontSize16">-->
<!--    完成本能力的学习-->
<!--  </div>-->
<!--</div>-->

<!--<div id="surveyBtn" (click)="goToPostSurvey()" *ngIf="showGoToSurveyBtn" class="fontSize16">-->
<!--  进入能力考核-->
<!--</div>-->
<!--<div id="surveyBtn" (click)="goToPostSurvey()" class="fontSize16">-->
  <!--返回学习主路径-->
<!--</div>-->

<components-swiper *ngIf="showReport" (Close)="goLearnPath15()"></components-swiper>
<component-momentview-pro *ngIf="showMoment" [momentList]="momentList" (onExit)="momentExit()"></component-momentview-pro>
<app-questionnaire [enter]="1" [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire && !type" (onExit)="closeQuestionnaire()" ></app-questionnaire>



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-pro-list/case-practice-influence-pro-list.component.html